export default __webpack_public_path__ + "static/media/photo_vide.0586a49b.svg";